module.exports = __webpack_public_path__ + "static/media/headshot.028149f7.jpeg";